import React, { useContext, useState, useEffect } from 'react';

const TranslationContext = React.createContext(null);

export const useTranslationContext = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error(
      'useTranslationContext must be used within a TranslationProvider'
    );
  }
  return context;
};

export const TranslationProvider = ({ children }) => {
  const [showTranslation, setShowTranslation] = useState(false);
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const storedLang = localStorage.getItem('preferred_language');
    if (storedLang && storedLang !== 'en') {
      setLanguage(storedLang);
      setShowTranslation(true);
    } else {
      setLanguage('en');
      setShowTranslation(false);
    }
  }, []);

  const toggleTranslation = (lang) => {
    if (lang === 'en') {
      localStorage.removeItem('preferred_language');
      setLanguage('en');
      setShowTranslation(false);
    } else {
      localStorage.setItem('preferred_language', lang);
      setLanguage(lang);
      setShowTranslation(true);
    }
  };

  return (
    <TranslationContext.Provider
      value={{ showTranslation, language, toggleTranslation }}
    >
      {children}
    </TranslationContext.Provider>
  );
};
